<template>
  <header id="gHeader">
    <h1>
      <a href="/">
        <span>株式会社アルク</span>
        <svg class="logo" xmlns="http://www.w3.org/2000/svg" width="8.93mm" height="17.24mm" viewBox="0 0 25.31 48.88">
          <path class="logo_ku" d="M18.12,28.81a2.21,2.21,0,0,0-.25.2c-.23.22-.45.42-.65.59s-.2.21-2.18,2.11c-1.3,1.2-3,2.64-5.75,4.72-.92.7-1.1.9-1.1,1.25s.2.65,2.23,2.2a74.54,74.54,0,0,1,8,6.83c.4.37.4.37.7.62l-1.58,1.55c-1.45-2-4.77-5-9.55-8.65-1.4-1.1-1.8-1.65-1.8-2.5a2.39,2.39,0,0,1,.73-1.67A20.07,20.07,0,0,1,9,34.35c3.23-2.47,6.53-5.54,7.33-6.84Z"/>
          <path d="M13.76,4.19V5H22.7A12.57,12.57,0,0,0,13.76,0Z"/>
          <path d="M23.67,6.41H13.76V9.9H25A12.82,12.82,0,0,0,23.67,6.41Z"/>
          <path d="M7.29,9.9h4.82V4.24c0-.26,0-1.93,0-4.24A12.48,12.48,0,0,0,7.29,1.18Z"/>
          <path d="M5.66,9.9V2.08A12.73,12.73,0,0,0,.3,9.9Z"/>
          <path d="M20.65,16.81a28.7,28.7,0,0,1-7.21,5.92,24.81,24.81,0,0,1-4.93,1.85A12.64,12.64,0,0,0,23.64,18.9,30,30,0,0,1,20.65,16.81Z"/>
          <path d="M13.76,11.42v6.25c0,1.26-.76,1.76-2.65,1.76-.84,0-1.67,0-2.64-.11a6.2,6.2,0,0,0-.42-1.67,15.62,15.62,0,0,0,2.93.28c.86,0,1.07-.1,1.07-.55v-6H.06A12,12,0,0,0,0,12.63,12.55,12.55,0,0,0,1.31,18.2,19,19,0,0,0,7.45,12l1.47.86a25.22,25.22,0,0,1-6.77,6.86A12.72,12.72,0,0,0,6,23.37a21.67,21.67,0,0,0,8.18-2.92,18.71,18.71,0,0,0,5-4.82,29.32,29.32,0,0,1-3-2.87l1.38-.87a28,28,0,0,0,6.81,5.44,12.69,12.69,0,0,0,.91-4.7,12,12,0,0,0-.06-1.21Z"/>
        </svg>
      </a>
    </h1>
    <div class="navTrigger">
      <span></span><span></span>
    </div>
  </header>
</template>

<script>
export default {
  name: 'gHeader'
}
</script>



// WEBPACK FOOTER //
// src/components/header.vue